import styled from "styled-components";
import { DivContentPage } from "../../components/common/DivContentPage";

const DivMain = styled(DivContentPage)`
  .div-filterRow {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    margin: 0 30px 12px 30px;
  }

  .btn-filter {
    border: 1.5px solid #e0e0e0;
    border-radius: 8px;
    padding: 6px 14px;
    cursor: pointer;
    font-size: 13px;
    font-weight: 500;
    color: #555;
    background: #fafafa;
    font-family: "Roboto", Helvetica, sans-serif;
    transition: all 0.15s;
    &.active {
      border-color: #222;
      background: #222;
      color: #fff;
    }
    &:hover:not(.active) {
      border-color: #aaa;
      background: #f2f2f2;
    }
  }

  .div-loadMore {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 14px 0;
    .btn-loadMore {
      border-radius: 10px;
      padding: 9px 28px;
    }
  }

  .cancellationsTable {
    .tag-driver {
      background: #fff3cd;
      color: #856404;
      border-radius: 20px;
      padding: 2px 10px;
      font-size: 11px;
      font-weight: 700;
      font-family: "Roboto";
    }
    .tag-passenger {
      background: #d1ecf1;
      color: #0c5460;
      border-radius: 20px;
      padding: 2px 10px;
      font-size: 11px;
      font-weight: 700;
      font-family: "Roboto";
    }
    .tag-status {
      border-radius: 20px;
      padding: 2px 10px;
      font-size: 11px;
      font-weight: 700;
      font-family: "Roboto";
      display: inline-flex;
      align-items: center;
      gap: 4px;
    }
    .tag-pending {
      background: #e5e7eb;
      color: #4b5563;
    }
    .tag-compensated {
      background: #dbeafe;
      color: #1e40af;
    }
    .tag-blocked {
      background: #fee2e2;
      color: #991b1b;
    }
    .tag-both {
      background: #f3e8ff;
      color: #6b21a8;
    }
  }
`;

const Styles = { DivMain };

export default Styles;
